import gql from "graphql-tag";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '{}';
let intermediateCondition = '';
if(cities && cities.length){
  let contractorCities = cities.map(curnt => curnt.city);
  finalCondition = '{contractorAddress: {city: {_in: '+ JSON.stringify(contractorCities) +'}}}'
}

export const GET_CONTRACTOR_DETAIL = gql`
query getContractorDetail($contractorId:uuid!){
  contractorDetail: contractor(where: {id: {_eq: $contractorId}}) {
    id
    name
    type
    contractorCode
    email
    gstin
    mobile
    monthlyKms
    status
    pan
    city
    contractorAddress{id add1 add2 area city state pincode}
    tempos{ id  platNo capacity}
    drivers{ id  name mobile driverType}
   }
}
`
export const GET_ALL_CONTRACTORS = gql`
query contractors($searchFilter: String!, $city:String){
   contractor (where: {_and: [{_or: [${finalCondition}] },{city: {_eq: $city}},
    {_or: [{name: {_ilike: $searchFilter}},{pan: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }]},
            order_by: {createdAt: asc}){
      id
      name
      type
      contractorCode
      email
      mobile
      monthlyKms
      gstin
      pan
      city
      status
      contractorAddress{id add1 add2 area city state pincode}
      tempoOrders_aggregate { aggregate { count } }
      tempos_aggregate { aggregate { count } }
      drivers_aggregate { aggregate { count } }
    }
  }
`
